const RADIUS_PX = {
    sharp: "2px",
    soft: "12px",
    round: "24px",
};

const COLOR_VARS = {
    bg: "--wd-bg",
    bgAlt: "--wd-bg-alt",
    surface: "--wd-surface",
    primary: "--wd-primary",
    primaryHover: "--wd-primary-hover",
    accent: "--wd-accent",
    accentSoft: "--wd-accent-soft",
    rose: "--wd-rose",
    roseDeep: "--wd-rose-deep",
    leaf: "--wd-leaf",
    text: "--wd-text",
    textMuted: "--wd-text-muted",
    border: "--wd-border",
    buttonText: "--wd-button-text",
};

function quotedFamily(name) {
    const family = String(name || "").trim();
    if (!family) return "serif";
    return `"${family.replace(/"/g, "")}"`;
}

export function themeStyle(theme) {
    const style = {};
    for (const [key, cssVar] of Object.entries(COLOR_VARS)) {
        style[cssVar] = theme.colors[key];
    }
    style["--wd-radius"] = RADIUS_PX[theme.radius] || RADIUS_PX.soft;
    style["--wd-font-display"] = `${quotedFamily(theme.fonts.display)}, cursive`;
    style["--wd-font-heading"] = `${quotedFamily(theme.fonts.heading)}, serif`;
    style["--wd-font-body"] = `${quotedFamily(theme.fonts.body)}, serif`;
    return style;
}

export function applyTheme(theme, element) {
    const style = themeStyle(theme);
    if (element?.style) {
        for (const [name, value] of Object.entries(style)) {
            element.style.setProperty(name, value);
        }
    }
    return style;
}
